<li v-if="route" :class="activeClass">
    <a
      ref="link"
      :class="[id, activeClass, ...classes]"
      :href="route"
      :data-modal="modalAttribute.value"
      :data-type="type"
    >
      {{ $t(label) }}
    </a>
</li>
